import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Skeleton from "react-loading-skeleton";
import { v4 as uuidv4 } from "uuid";
import { UnoStoreHooks, UiComponents, initialize } from "@simulanisindia/ui";
import Modal from "react-bootstrap/Modal";
import { AudioPrev, CheckIcon, MediaCheckIcon, PDFPrev, PlusIcon, VideoPrev, XIcon } from "../../assets/icons/icons";
import pdfIcon from "../../assets/img/pdf.png";
import { AUDIO, IMAGE, PDF, VIDEO } from "../../constant/constant";
import { getFileType } from "../../utils/general";
import { useParams } from "react-router-dom";
import apiclient from "../../apiclient";
import axios from "axios";
import { saveInventoryList } from "../../store/slice/projectSlice";
import SpinnerLoader from "../skeleton/loader";
import { INVENTORY_SAVE } from "../../apiclient/apiEndpoints";
import { generateThumbnailFromFile } from "../../utils/common";

export const allowedFileTypes = ["image/jpeg", "image/png", "video/mp4", "audio/mpeg", "application/pdf"];

const getAcceptType = (type) => {
  switch (type) {
    case IMAGE:
      return "image/*";
    case VIDEO:
      return "video/*";
    case PDF:
      return "application/pdf";
    case AUDIO:
      return "audio/*";
    default:
      return "*/*";
  }
};

const { useUnoSelector } = UnoStoreHooks;

const LibraryPopup = ({ show, handleClose, handleChangeScene, showTabs = [], selectedId = null }) => {
  const dispatch = useDispatch();
  const configData = useUnoSelector((state) => state.config);
  const userData = useUnoSelector((state) => state.user);
  const { uuid } = useParams();
  const [activeTab, setActiveTab] = useState(IMAGE);
  const [inventoryType, setInventoryType] = useState([
    { name: "Images", type: IMAGE },
    { name: "Videos", type: VIDEO },
    { name: "Pdf", type: PDF },
    { name: "Audio", type: AUDIO },
  ]);
  const [selectedInventoryId, setSelectedInventoryId] = useState(null);
  const { inventoryList } = useSelector((state) => state.projectSlice);
  const [filteredInventory, setFilteredInventory] = useState({
    [IMAGE]: [],
    [VIDEO]: [],
    [PDF]: [],
    [AUDIO]: [],
  });

  useEffect(() => {
    setSelectedInventoryId(selectedId);
  }, [selectedId]);

  useEffect(() => {
    setFilteredInventory({
      [IMAGE]: inventoryList.filter((e) => e.fileType === IMAGE).reverse(),
      [VIDEO]: inventoryList.filter((e) => e.fileType === VIDEO).reverse(),
      [PDF]: inventoryList.filter((e) => e.fileType === PDF).reverse(),
      [AUDIO]: inventoryList.filter((e) => e.fileType === AUDIO).reverse(),
    });
  }, [inventoryList]);

  const handleFileChange = async (files) => {
    const updatedFiles = Array.from(files).map(({file, imageBase64 }, index) => ({
      file,
      progress: 0,
      uploading: true,
      preview: URL.createObjectURL(file),
      imageBase64: imageBase64,
      isNew: true,
      newId: uuidv4()
    }));

    setFilteredInventory((pre) => ({
      ...pre,
      [activeTab]: [...updatedFiles, ...pre[activeTab]],
    }));

    const uploadPromises = updatedFiles.map((fileObj) => uploadFile(fileObj.file, fileObj.imageBase64, fileObj.newId));
    let _list = await Promise.all(uploadPromises);
    handleSubmit(_list);

  };

  const updateFileProgress = (file, path, fileType, currentActiveTab, thumbnail, newId) => {
    
    setFilteredInventory((prev) => {
      const updatedTabItems = prev[currentActiveTab].map((item) =>
        item?.newId === newId ? 
          {
              ...item,
              name: file.name,
              path,
              fileType,
              uploading: false,
              thumbnail: thumbnail
            }
          :
           item
      );

      return {
        ...prev,
        [currentActiveTab]: updatedTabItems,
      };
    });
  };

  const uploadFile = async (file, imageBase64, newId) => {
    const formData = new FormData();
    formData.append("file", file);
    if(imageBase64){ formData.append("imageBase64", imageBase64) }

    const fileType = getFileType(file.type);

    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await axios.post(
          `${configData.config.API_URL}/api/inventory/upload/${uuid}/${fileType}`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${userData?.token}`,
              "Content-Type": "multipart/form-data",
            }
          }
        );

        updateFileProgress(file, data?.url, fileType, activeTab, data?.videoThumbnail || data?.imageThumbnail, newId);
        resolve({ originalName: file.name, path: data.url, fileType, thumbnail: data?.videoThumbnail || data?.imageThumbnail});
      } catch (error) {
        console.log(error.message);
        reject(error);
      }
    });
  };

  const handleInputChange = async(event) => {
    const files = event.target.files;
    const validFiles = [];

    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      let imageBase64 = null;
      const fileType = file.type;
      const isValidType = (activeTab === IMAGE && fileType.startsWith("image/")) || (activeTab === VIDEO && fileType.startsWith("video/")) || (activeTab === PDF && fileType === "application/pdf") || (activeTab === AUDIO && fileType.startsWith("audio/"));
      if(activeTab === IMAGE){
        imageBase64 = await generateThumbnailFromFile(file);
      }
      if (isValidType) validFiles.push({file, imageBase64 });
    }

    if (validFiles.length > 0) handleFileChange(validFiles);
     event.target.value = '';   
  };

  const handleSubmit = async (_list) => {
    try {
      let _data = { data: _list };

      let { data } = await axios.post(`${configData.config.API_URL}${INVENTORY_SAVE}/${uuid}`, _data, {
        headers: {
          Authorization: `Bearer ${userData?.token}`,
        },
      });

      dispatch(saveInventoryList({ data: data.data }));
    } catch (error) {
      console.log(error.message);
    }
  };

  const renderItems = (items, type, inventoryId) => {
    return (
      <>
        <div className="libraryItem add">
          <PlusIcon />
          <input
            type="file"
            id="fileUpload"
            name="fileUpload"
            multiple
            onChange={handleInputChange}
            accept={getAcceptType(activeTab)}
          />
        </div>

        {items.map((item, index) => {
          const { isNew, path, preview, uuid, name, thumbnail } = item;
          const filePath = isNew ? preview : path;
          const isSelected = uuid === inventoryId;

          const renderInventoryContent = () => {
            switch (type) {
              case IMAGE:
                return isNew ? (
                  <SpinnerLoader />
                ) : (
                  <img src={thumbnail || filePath} alt="Library Item" style={{ width: "100%", height: "auto" }} />
                );
              case VIDEO:
                return !isNew ? ( !thumbnail ? <div className="svg-Prev"> <VideoPrev /> </div> : <img src={thumbnail} alt="Library Item" style={{ width: "100%", height: "auto" }} />) : <SpinnerLoader />;

              case PDF:
              case AUDIO:
                return (
                  <>
                    {!isNew ?
                    <div className="svg-Prev">{type === PDF ? <PDFPrev /> : <AudioPrev />}</div>
                    :
                    <SpinnerLoader />
                    }
                  </>
                );

              default:
                return null;
            }
          };

          return (
            <div
              className={`libraryItem ${isNew ? "loading" : ""} ${isSelected ? "selectedItem" : ""} `}
              key={index}
              onClick={() => handleSelectScene(item)}
            >
              {renderInventoryContent()}
              {isSelected && 
              <span className="selected">
                <MediaCheckIcon/>
              </span>
                }
              <p title={name}>{isNew ? <Skeleton width="100%" height="1rem" /> : name}</p>
            </div>
          );
        })}
      </>
    );
  };

  const handleSelectScene = (item) => {
    if (handleChangeScene) handleChangeScene(item);
  };

  const filteredInventoryType = showTabs?.length
    ? inventoryType.filter((item) => showTabs.includes(item.type))
    : inventoryType;

  return (
    <Modal show={show} size="xl" centered onHide={handleClose} className="editorModal">
      <Modal.Header>
        <Modal.Title>Libraries</Modal.Title>
        <div className="modalHeaderFunction">
          <span className="modalClose" onClick={handleClose}>
            <XIcon />
          </span>
        </div>
      </Modal.Header>

      <Modal.Body>
        <div className="libraryContent">
          <div className="customDataTabs">
            {filteredInventoryType.map(({ name, type }) => (
              <span
                key={type}
                className={`dataTab ${activeTab === type ? "active" : ""}`}
                onClick={() => setActiveTab(type)}
              >
                {name}
              </span>
            ))}
          </div>
          <div className="libraryData">
            {renderItems(filteredInventory[activeTab] || [], activeTab, selectedInventoryId)}
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default LibraryPopup;
